"use strict";
exports.__esModule = true;
exports.CrmDefaults = void 0;
var luxon_1 = require("luxon");
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var PlatformProducerOrder_1 = require("./order/PlatformProducerOrder");
var PlatformMerchantOrder_1 = require("./order/PlatformMerchantOrder");
var MerchantCustomerOrder_1 = require("./order/MerchantCustomerOrder");
var CrmDefaults = /** @class */ (function () {
    function CrmDefaults() {
    }
    CrmDefaults.timezone = luxon_1.FixedOffsetZone.parseSpecifier('UTC+2');
    CrmDefaults.shopifyOrderSyncBatchSize = 5;
    CrmDefaults.referenceMarkerPieceInventory = function (pieceId, pieceModelId, pieceConfiguration) {
        var pieceReferenceId = pieceId + "-" + pieceModelId + "-" + JSON.stringify(pieceConfiguration);
        return "undefined-piece-inventory-reference " + pieceReferenceId;
    };
    CrmDefaults.referenceMarkerAccessoryInventory = function (accessoryId, accessoryModelId, accessoryConfiguration) {
        var accessoryReferenceId = accessoryId + "-" + accessoryModelId + "-" + JSON.stringify(accessoryConfiguration);
        return "undefined-accessory-inventory-reference " + accessoryReferenceId;
    };
    CrmDefaults.referenceMarkerPricing = new Map([
        [core_common_domain_1.Currency.EUR, { currency: core_common_domain_1.Currency.EUR, amount: 1 }],
        [core_common_domain_1.Currency.USD, { currency: core_common_domain_1.Currency.USD, amount: 1 }]
    ]);
    /* The main platform defaults (e-mails defined in boostrap CLI configs) */
    CrmDefaults.platformDomainName = 'jewelutions.com';
    CrmDefaults.platformPartyId = 'b45664cb-183a-4a36-820e-3170710939e8';
    CrmDefaults.platformPartyName = 'Jewelutions BV';
    CrmDefaults.platformPartyAddress = {
        street: 'Graaf Florislaan',
        streetNumber: '2A',
        streetExtra: '',
        postcode: '1217KK',
        city: 'Hilversum',
        country: core_common_domain_1.Country.NETHERLANDS
    };
    CrmDefaults.platformAdminUser1Id = 'b45664cb-083a-4aa6-820e-31707a093991';
    CrmDefaults.platformPartyShopifyAppToken = 'd45664cb-d83a-daa6-d20e-d1707d0939e7';
    /* The platform prototype merchant party & channel */
    CrmDefaults.platformPrototypeMerchantDomainName = 'prototype-merchant-jewelutions.com';
    CrmDefaults.platformPrototypeMerchantPartyId = 'b45664cd-083a-4aa6-820e-31707a093982';
    CrmDefaults.platformPrototypeMerchantPartyName = 'Jewelutions Prototype Merchant BV';
    CrmDefaults.platformPrototypeMerchantPartyAddress = {
        street: 'Graaf Florislaan',
        streetNumber: '2A',
        streetExtra: '',
        postcode: '1217KK',
        city: 'Hilversum',
        country: core_common_domain_1.Country.NETHERLANDS
    };
    /** We need the prototype merchant as we use it as a origin to create new merchants.  */
    CrmDefaults.platformPrototypeMerchantAdminUser1Email = 'platform-prototype-merchant@example.com';
    CrmDefaults.platformPrototypeMerchantAdminUser1Id = 'b45664cd-083a-5aa6-820e-31707a093983';
    CrmDefaults.noAccessToken = 'NO_ACCESS_TOKEN';
    CrmDefaults.platformPrototypeMerchantChannelId = 'b45664cd-083a-5aa6-820e-31707a093984';
    CrmDefaults.platformPrototypeMerchantChannelCatalogId = 'b45664cd-083a-5aa6-820e-31707a093985';
    /* The main producer defaults (e-mails defined in boostrap CLI configs) */
    CrmDefaults.mainProducerPartyId = 'b45664cb-083a-4aa6-820e-31707a0939e8';
    CrmDefaults.mainProducerPartyName = 'Jewelutions Production LTD';
    CrmDefaults.mainProducerPartyAddress = {
        street: 'Main street',
        streetNumber: '12',
        streetExtra: '',
        postcode: 'ABCDE12',
        city: 'Hong Kong',
        country: core_common_domain_1.Country.CHINA
    };
    CrmDefaults.mainProducerAdminUser1Id = 'b45664cb-083a-4aa6-820e-31707a093992';
    /* The main producer - primary delivery unit */
    CrmDefaults.mainProducerPrimaryDeliveryUnitId = 'd45664cb-083a-4aa6-820e-31707a0939ed';
    CrmDefaults.mainProducerPrimaryDeliveryUnitName = 'Hong Kong Delivery Unit';
    CrmDefaults.mainProducerPrimaryDeliveryUnitAddress = {
        street: 'Main street',
        streetNumber: '12',
        streetExtra: '',
        postcode: 'ABCDE12',
        city: 'Hong Kong',
        country: core_common_domain_1.Country.CHINA
    };
    /* The main producer - secondary delivery unit */
    CrmDefaults.mainProducerSecondaryDeliveryUnitId = 'd45664cb-083a-4aa6-820e-31707a0939ee';
    CrmDefaults.mainProducerSecondaryDeliveryUnitName = 'Amsterdam Delivery Unit';
    CrmDefaults.mainProducerSecondaryDeliveryUnitAddress = {
        street: 'Seconddary street',
        streetNumber: '11',
        streetExtra: '',
        postcode: 'ABCDE11',
        city: 'Amsterdam',
        country: core_common_domain_1.Country.NETHERLANDS
    };
    /* The main producer demo merchant defaults - primary (e-mails defined in boostrap CLI configs) */
    CrmDefaults.platformMainProducerPrimaryDeliveryUnitMerchantDemoPartyId = 'b45664cb-083a-4aa6-820e-31707a093993';
    CrmDefaults.platformMainProducerPrimaryDeliveryUnitMerchantDemoAdminUser1Id = 'b45664cb-083a-4aa6-820e-31707a093994';
    /* The main producer demo merchant defaults - secondary (e-mails defined in boostrap CLI configs) */
    CrmDefaults.platformMainProducerSecondaryDeliveryUnitMerchantDemoPartyId = 'b45664cb-083a-4aa6-820e-31707a093995';
    CrmDefaults.platformMainProducerSecondaryDeliveryUnitMerchantDemoAdminUser1Id = 'b45664cb-083a-4aa6-820e-31707a093996';
    CrmDefaults.defaultWeightUnit = core_common_domain_1.WeightUnit.GRAMS;
    CrmDefaults.defaultCurrency = core_common_domain_1.Currency.EUR;
    CrmDefaults.defaultLanguage = core_common_domain_1.Language.ENGLISH;
    CrmDefaults.availableLanguages = [core_common_domain_1.Language.ENGLISH];
    CrmDefaults.viewer3DEnvironmentProfileId = 'a4a6a4cb-a83a-4aa6-a20e-a1707a09399a';
    CrmDefaults.viewer3DEnvironmentProfileName = 'Standard';
    CrmDefaults.orderStateMapper = {
        platformProducerToPlatformMerchant: new Map([
            [PlatformProducerOrder_1.PlatformProducerOrderState.NEW, PlatformMerchantOrder_1.PlatformMerchantOrderState.NEW],
            [PlatformProducerOrder_1.PlatformProducerOrderState.IN_PRODUCTION, PlatformMerchantOrder_1.PlatformMerchantOrderState.IN_PRODUCTION],
            [PlatformProducerOrder_1.PlatformProducerOrderState.SHIPPED, PlatformMerchantOrder_1.PlatformMerchantOrderState.SHIPPED],
            [PlatformProducerOrder_1.PlatformProducerOrderState.CANCELED, PlatformMerchantOrder_1.PlatformMerchantOrderState.CANCELED],
            [PlatformProducerOrder_1.PlatformProducerOrderState.REJECTED, PlatformMerchantOrder_1.PlatformMerchantOrderState.REJECTED],
            [PlatformProducerOrder_1.PlatformProducerOrderState.COMPLETED, PlatformMerchantOrder_1.PlatformMerchantOrderState.COMPLETED]
        ]),
        platformMerchantToMerchantCustomer: new Map([
            [PlatformMerchantOrder_1.PlatformMerchantOrderState.NEW, MerchantCustomerOrder_1.MerchantCustomerOrderState.NEW],
            [PlatformMerchantOrder_1.PlatformMerchantOrderState.IN_PRODUCTION, MerchantCustomerOrder_1.MerchantCustomerOrderState.IN_PRODUCTION],
            [PlatformMerchantOrder_1.PlatformMerchantOrderState.SHIPPED, MerchantCustomerOrder_1.MerchantCustomerOrderState.SHIPPED],
            [PlatformMerchantOrder_1.PlatformMerchantOrderState.CANCELED, MerchantCustomerOrder_1.MerchantCustomerOrderState.CANCELED],
            [PlatformMerchantOrder_1.PlatformMerchantOrderState.REJECTED, MerchantCustomerOrder_1.MerchantCustomerOrderState.REJECTED],
            [PlatformMerchantOrder_1.PlatformMerchantOrderState.COMPLETED, MerchantCustomerOrder_1.MerchantCustomerOrderState.COMPLETED]
        ])
    };
    return CrmDefaults;
}());
exports.CrmDefaults = CrmDefaults;
